import { useLogout } from '@Hooks/useMsal';
import { useEffect, useRef } from 'react';

/**
 * Signs the user out when mounted. Reaching it is a navigation, so edit frames can still warn about unsaved changes.
 *
 * @ai-generated 2026-09-29T07:29:39+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5
 */
export const Signout = () => {
    const logout = useLogout();
    const hasStartedRef = useRef(false);

    useEffect(() => {
        if (hasStartedRef.current) {
            return;
        }
        hasStartedRef.current = true;
        void logout();
    }, [logout]);

    return null;
};
